export default {
    atmosInitialized: false,
    atmosSubscriptions: [],
    atmosSubscription: null,
    atmosAppTypes: null,
    atmosAppsRefreshing: false,
    atmosApps: [],
    
    showPrereleases: false,    
    showVersions: false,
}
  